document.addEventListener('click', function (event) {
  const trigger = event.target.closest('.sizeguide [data-tab-trigger]');
  if (!trigger) return;

  const targetSelector = trigger.getAttribute('href');
  if (!targetSelector || !targetSelector.startsWith('#')) return;

  const root = trigger.closest('.sizeguide');
  if (!root) return;

  const targetPane = root.querySelector(targetSelector);
  if (!targetPane) return;

  event.preventDefault();

  root.querySelectorAll('[data-tab-trigger]').forEach((tab) => {
    tab.classList.remove('active');
    tab.setAttribute('aria-selected', 'false');
  });

  root.querySelectorAll('.tab-pane').forEach((pane) => {
    pane.classList.remove('active', 'show');
  });

  trigger.classList.add('active');
  trigger.setAttribute('aria-selected', 'true');
  targetPane.classList.add('active', 'show');
});
